<template>
    <div>
        <!-- Side Panel Overlay -->
        <div
            class="side-panel-overlay"
            :class="{ show: show }"
            @click.stop="close"
        ></div>

        <!-- Side Panel -->
        <div class="side-panel" :class="{ show: show }">
            <div class="title">
                <h4 class="m-0">{{ title }}</h4>
                <i class="fas fa-times cursor-pointer" @click.stop="close"></i>
            </div>

            <div class="content-holder" id="side-panel-content">
                <slot></slot>
            </div>

            <div class="panel-footer">
                <slot name="footer">
                    <button :class="cancelButtonClass" @click="close">
                        {{ cancelText }}
                    </button>
                    <button
                        :class="confirmButtonClass"
                        @click="$emit('confirm')"
                        :disabled="disabled"
                    >
                        {{ confirmText }}
                    </button>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SidePanel",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        confirmText: {
            type: String,
            default: "Confirm"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        cancelText: {
            type: String,
            default: "Cancel"
        },
        cancelButtonClass: {
            type: String,
            default: "btn btn-light mr-2"
        },
        confirmButtonClass: {
            type: String,
            default: "btn btn-dark"
        }
    },
    watch: {
        show: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "";
                }
            }
        }
    },
    methods: {
        close() {
            this.$emit("update:show", false);
        }
    },
    beforeDestroy() {
        // Reset body overflow when component is destroyed
        document.body.style.overflow = "";
    }
};
</script>

<style scoped>
.side-panel-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: transparent;
    z-index: 1040;
    display: none;
}

.side-panel-overlay.show {
    display: block;
}

.side-panel {
    background: #ffffff;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 64px;
    right: -400px;
    width: 400px;
    max-width: 100vw;
    height: calc(100vh - 64px);
    overflow-y: auto;
    z-index: 1041;
    display: flex;
    flex-direction: column;
    transition: right 0.3s ease;
}

.side-panel.show {
    right: 0;
}

.side-panel .title {
    padding: 1.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dbdbdb;
    background: #fff;
}

.side-panel .title h4 {
    font-weight: 600;
    margin: 0;
}

.side-panel .title i {
    cursor: pointer;
    opacity: 0.7;
}

.side-panel .title i:hover {
    opacity: 1;
}

.side-panel .content-holder {
    flex: 1;
    overflow-y: auto;
    background: #fff;
    -webkit-overflow-scrolling: touch;
}

.side-panel .panel-footer {
    padding: 1.3rem;
    border-top: 1px solid #dbdbdb;
    display: flex;
    justify-content: flex-end;
    background: #fff;
}
</style>
